import { useState, useEffect } from "react";
import { GigyaGroupModels } from "../types/gigya.schema";

export const useSetGroupInfo = () => {
  const [groupId, setGroupInfoId] = useState("");
  const [removedUsers, setRemovedUsers] = useState<Array<string> | undefined>(
    undefined,
  );
  const [loadingGroupInfoResp, setLoadingGroupInfoResp] = useState(true);
  const [groupInfoRespError, setGroupInfoRespError] = useState(false);
  const [groupInfoResp, setGroupInfoResp] = useState("");

  useEffect(() => {
    if (groupId && removedUsers) {
      window.gigya.accounts.groups.setGroupInfo({
        model: GigyaGroupModels.ClinicModel,
        groupId,
        groupData: {
          removedUsers,
        },
        callback: (resp) => {
          if (resp.errorCode) {
            console.log("Error Details: ", resp.errorDetails);
            setLoadingGroupInfoResp(true);
            setGroupInfoRespError(true);
          } else {
            setGroupInfoResp(resp.errorDetails);
            setLoadingGroupInfoResp(false);
            setGroupInfoRespError(false);
          }
        },
      });
    }

    return () => {
      setGroupInfoResp("");
      setGroupInfoId("");
      setRemovedUsers(undefined);
      setLoadingGroupInfoResp(true);
      setGroupInfoRespError(false);
    };
  }, [groupId, removedUsers]);

  return {
    setGroupInfoId,
    setRemovedUsers,
    groupInfoResp,
    loadingGroupInfoResp,
    groupInfoRespError,
  };
};
